module.exports = __webpack_public_path__ + "img/animation-group-logo.e1be170e.webp";